import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material';
import { ErrorBoundary } from './config/bugsnag';
import ErrorView from './components/error-view';
import en from './translations/en.json';
import es from './translations/es.json';
import pt from './translations/pt.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    es: {
      translation: es,
    },
    pt: {
      translation: pt,
    },
  },
  lng: 'en',
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#3272F0',
    },
    secondary: {
      main: '#3272F0',
    },
    error: {
      main: '#f33f06',
    },
    success: {
      main: '#21a35b',
    },
  },
});

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        {ErrorBoundary ? (
          <ErrorBoundary FallbackComponent={ErrorView}>
            <App />
          </ErrorBoundary>
        ) : (
          <App />
        )}
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
